import { render, staticRenderFns } from "./VideoRoom2.vue?vue&type=template&id=c4c21eee"
import script from "./VideoRoom2.vue?vue&type=script&lang=js"
export * from "./VideoRoom2.vue?vue&type=script&lang=js"
import style0 from "./VideoRoom2.vue?vue&type=style&index=0&id=c4c21eee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports